import { IntlProvider } from '@/context/IntlContext';
import { getConfig } from '@/helpers/config';
import { useGetUserInfoQuery } from '@/state/api/web.api';
import type { AppStore } from '@/state/store';
import type { PropsWithChildren } from 'react';
import { AppCrash } from './AppCrash';
import { CrashModal } from './Modals/CrashModal/CrashModal';
import { PageLayout } from './layout/PageLayout';

import './App.scss';
import { useTimeout } from '@/state/hooks';
import { DuplicatedSessionModal } from './Modals/DuplicatedSessionModal/DuplicatedSessionModal';
import { ServiceLoader } from './layout/components/ServiceLoader';
import { UserInfoContextProvider } from './UserInfoContextProvider';
import { Provider } from 'react-redux';

export function App({ store }: { store: AppStore }) {
  return (
    <IntlProvider>
      <Provider store={store}>
        <UserInfoContextProvider>
          <AppCrash>
            <CheckAuthorizations>
              <PageLayout />
            </CheckAuthorizations>
          </AppCrash>
          <CrashModal />
          <DuplicatedSessionModal />
        </UserInfoContextProvider>
      </Provider>
    </IntlProvider>
  );
}

function CheckAuthorizations({ children }: PropsWithChildren<object>): JSX.Element {
  const userInfo = useGetUserInfoQuery();
  const timeout = useTimeout(800);

  if (userInfo.isLoading || !timeout) {
    return <ServiceLoader />;
  }

  if (userInfo.isSuccess && Boolean(userInfo.data?.hasAccess)) {
    return <>{children}</>;
  }

  if (userInfo.isError) {
    return <RedirectUnauthorized />;
  }

  return <ServiceLoader />;
}

function RedirectUnauthorized(): null {
  const { unauthorized_url } = getConfig();

  window.location.assign(unauthorized_url);
  return null;
}
